/**
 * One-time pdf.js setup shared by the PDF viewer and the poster preview.
 * Both go through react-pdf's `pdfjs` so they use the same worker.
 */

// Vite bundles the worker as a separate asset on first viewer load.
// Tauri's WebView serves it from the same origin → no CSP changes needed.
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

// Tell pdf.js where to find its CMaps & standard fonts. We pin the URL
// to the exact `pdfjs.version` we're running with — otherwise unpkg may
// serve a newer minor that mismatches the API.
// (CMaps allow rendering of non-Latin fonts in older PDFs.)
export const PDF_OPTIONS = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
} as const;

export { pdfjs };
